//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment-timezone'
import DateRange from '../../atoms/date-range/date-range.vue';

let defaultImage = require('../../../images/default_images/default_event_thumbnail.png');

export default {
  components: {
    'date-range': DateRange,
  },
  props: {
    thumbnail: {
      type: String,
      default: defaultImage,
    },
    title: String,
    start: Date,
    end: Date,
    location: String,
    timezone: String,
    showTimezone: {
      type: Boolean,
      default: true
    },
    url: String,
  },
  data() {
    return {
      image: this.thumbnail || defaultImage,
    };
  },
  methods: {
    onImageLoadError() {
      this.image = defaultImage;
    }
  },
}



// WEBPACK FOOTER //
// ./app/components/molecules/event-card/event-card.vue